const schemeRegex = /^([a-z][a-z0-9+.-]*:)/i;

// Browsers drop tabs and newlines before reading the scheme, so "java\tscript:" is javascript:.
export const getUrlScheme = (value: string): string | undefined =>
  value
    .replace(/[\t\n\r]/g, '')
    .trim()
    .toLowerCase()
    .match(schemeRegex)?.[1];

const LINK_OUT_PROTOCOLS = ['http:', 'https:'];

// Provider urls are attacker-controlled and reach window.open / Linking.openURL unescorted.
export const sanitizeExternalUrl = (
  value: string | null | undefined,
): string | undefined => {
  if (!value) {
    return undefined;
  }

  const scheme = getUrlScheme(value);

  if (!scheme || !LINK_OUT_PROTOCOLS.includes(scheme)) {
    return undefined;
  }

  return value;
};
